<div class="align-items-center justify-content-center d-flex flex-column mx-md-0 mx-3 auth-layout">
  <div class="auth">
    <div class="auth-container mx-auto bg-white col-md-3 px-3 animate__animated animate__fadeIn">

      <!-- <div class="col-md-12 px-0 text-end justify-content-end">
        <button [matMenuTriggerFor]="langMenu" class="example-icon favorite-icon" mat-icon-button>
          <mat-icon>g_translate</mat-icon>
        </button>

        <mat-menu #langMenu="matMenu">
          @for (language of translate.getLangs(); track language) {
            <button (click)="switchLang(language)"
              mat-menu-item> {{ language | translate }}
            </button>
          }
        </mat-menu>
      </div> -->


      <div class="row">
        <div class="col-md-12 py-3">
          <div class="col-md-12 text-center">
            <img alt="Logo" class="w-20" src="/assets/images/logo_aqrb.png">
            <h1 class="auth-title">{{ 'AQRBMIS' | translate}}</h1>
          </div>
          <ng-container *ngTemplateOutlet="AuthContent"></ng-container>
        </div>
      </div>
    </div>
  </div>


  <div class="text-center mt-2 col-md-12 footer-content">
    &copy; {{ currentYear }} - {{ 'design-by' | translate}}
    <a href="https://www.ega.go.tz" target="_blank" title="{{ 'ega' | translate}}">
      e-GA
    </a> <br>
    <!-- {{ 'footer-content' | translate}} -->
  </div>

</div>






<!--Waves Container-->
<!--<svg class="waves" preserveAspectRatio="none" shape-rendering="auto"-->
<!--     viewBox="0 24 150 28" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">-->
<!--  <defs>-->
<!--    <path d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" id="gentle-wave" />-->
<!--  </defs>-->
<!--  <g class="parallax">-->
<!--    <use fill="rgba(255,255,255,0.7" x="48" xlink:href="#gentle-wave" y="0" />-->
<!--    <use fill="rgba(255,255,255,0.5)" x="48" xlink:href="#gentle-wave" y="3" />-->
<!--    <use fill="rgba(255,255,255,0.3)" x="48" xlink:href="#gentle-wave" y="5" />-->
<!--    <use fill="#fff" x="48" xlink:href="#gentle-wave" y="7" />-->
<!--  </g>-->
<!--</svg>-->
<!--Waves end-->

